import React from 'react';
import { List, Tag } from 'app/seedly-component-library';
import Link from 'next/link';
import { Tag as ProductTagIcon } from 'react-feather';

const iconTagStyle = {
  height: 13,
  width: 13,
  margin: 'auto 0',
  marginRight: 3,
};

const ProductLinkList = props => {
  const { productTags = [] } = props;

  const tagList = productTags.map(product => {
    const { slug, name, categorySlug, id } = product;

    const formatTitle = (
      <>
        <ProductTagIcon style={iconTagStyle} /> {name}
      </>
    );

    if (!slug || !categorySlug) {
      return <Tag key={id} title={name} />;
    }

    const productLink = `/reviews/${categorySlug}/${slug}`;

    return (
      <Link key={id} passHref href={productLink} as={productLink}>
        <Tag renderAs="a" title={formatTitle} target="_blank" />
      </Link>
    );
  });

  return <List dataSource={tagList} alignment="horizontal" />;
};

export default ProductLinkList;
